import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import {
  driverDetailsWithId,
  driverAllDetails,
  addDriverUpdatedDetail,
  doubleDriverReduxDetail,
  driverVerificationDetailsWithID,
} from "../slices/driverSlice";
import roleReducer from "../slices/roleSlice";
import { agentsLists, reduxCarList } from "../slices/hub_manager";
import { rentalSchemeDetails, stateOptions, documentsModal } from "../slices/driverCommon";
// import {driverDetailsWithId,driverAllDetails} from '../slices/driverSlice'
// import {rentalSchemeDetails} from '../slices/driverCommon';
import { hubManagerData } from "../slices/hub_manager";
import userReducer, { userDetailsWithId } from "../slices/userSlice";
import {
  allFleetHubAPIDetails,
  fleetWithIdSliceDetails,
  fleetFormDropdownListsDetails,
  fleetImageIdSliceDetails,
} from "../slices/procurement";
import {
  FleetManagemntAllDashboardDetails,
  FetchFleetRecoveryDetails,
} from "../slices/fleet_management";
import { tallyTableTransactionCount } from "../slices/tally";
import jobsSlice from "../slices/jobsSlice";

import requestCountReducer from "../slices/countSlice";
import { agentSlice, crmLeadDetailsSlice } from "../slices/crmSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    requestCount: requestCountReducer,
    driverDetailsWithId: driverDetailsWithId,
    driverAllDetails: driverAllDetails,
    addDriverUpdatedDetail: addDriverUpdatedDetail,
    role: roleReducer,
    agentsLists: agentsLists,
    reduxCarList: reduxCarList,
    rentalSchemeDetails: rentalSchemeDetails,
    hubManagerData: hubManagerData,
    stateOptions: stateOptions,
    doubleDriverReduxDetail: doubleDriverReduxDetail,
    // driverVerificationDetailsWithID:driverVerificationDetailsWithID
    // driverVerificationDetailsWithID:driverVerificationDetailsWithID,
    user: userReducer,
    allFleetHubAPIDetails: allFleetHubAPIDetails,
    fleetWithIdDetails: fleetWithIdSliceDetails,
    fleetFormDropdownListsDetails: fleetFormDropdownListsDetails,
    fleetImageIdSliceDetails: fleetImageIdSliceDetails,
    FleetManagemntAllDashboardDetails: FleetManagemntAllDashboardDetails,
    FetchFleetRecoveryWithID: FetchFleetRecoveryDetails,
    tallyTableTransactionCount: tallyTableTransactionCount,
    documentsModal: documentsModal,
    userDetailsWithId: userDetailsWithId,
    jobs: jobsSlice,
    agentSlice: agentSlice,
    crmLeadDetailsSlice: crmLeadDetailsSlice,
  },
});

export default store;
